/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import Select, { components } from 'react-select';
import withStyles from 'react-jss';
import i18n from 'i18next';
import { Translation } from 'react-i18next';
import validate from '../utility/CheckError';
import ErrorMessage from '../ErrorMessage';
import countriesListEn from '../../util/countriesList.json';
import countryTerritoriesEn from '../../util/countryTerritories.json';
import { getAuthState, getOnboardingState } from '../../store/selectors';
import { getSchools, updateUserProfile } from '../../store/actions';
import { getSSOProvider } from '../utility/getSSOProvider';
import eyeIcon from '../../ASUPhotos/icons/eyeIcon.png';
import eyeCrossIcon from '../../ASUPhotos/icons/eyeCrossIcon.png';
import DropDownIndicator from '../utility/DropDownIndicator';
import ChangesSaved from '../utility/ChangesSaved';
import Chevron from './utility/Chevron';
import { educationLevels } from '../../copy/educationLevels';
import WindowTitle from '../utility/WindowTitle';

const styles = {
  nonFilledButton: (props) => ({
    color: props.tenant.primary,
    border: `1px solid ${props.tenant.primary}`,

    '&:hover': {
      backgroundColor: props.tenant.primary,
    },
  }),

  filledButton: (props) => ({
    borderColor: `${props.tenant.primary}`,
    backgroundColor: `${props.tenant.primary}`,

    '&:hover': {
      border: `2px solid ${props.tenant.primary}`,
      color: `${props.tenant.primary}`,
    },
  }),

  filledButtonDisabled: (props) => ({
    color: 'white !important',
    borderColor: `${props.tenant.primary}`,
    backgroundColor: 'lightgrey',
  }),
};

export class EditProfile extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.highSchoolSelect = React.createRef();
    this.state = {
      dob: '',
      currentPassword: '',
      password: '',
      confirmPass: '',
      state: '',
      country: '',
      education: '',
      highSchool: '',
      graduationYear: '',
      listOfTerritories: {},
      listOfSchools: {},
      listOfCountries: {},
      errorsPresent: false,
      currentPasswordIsMasked: true,
      passwordIsMasked: true,
      confirmPassIsMasked: true,
      passwordSuccess: false,
      updateProfileSuccess: false,
      changesMade: false,
      currentLocale: i18n.language,
      countriesList: {},
      countryTerritories: {},
      errors: {
        dob: false,
        currentPassword: false,
        password: false,
        confirmPass: false,
        highSchool: false,
        somethingwentWrong: false,
        state: false,
        gradYear: false,
      },
    };
  }

  customStyles = {
    control: (provided) => ({
      ...provided,
      height: '100%',
      borderRadius: '7px',
    }),
    option: (provided) => ({
      ...provided,
      color: this.props.tenant.primary,
    }),
    input: (provided) => ({
      ...provided,
      color: this.props.tenant.primary,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'black',
      paddingLeft: '12px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'black',
      overflow: 'visible',
      paddingLeft: '12px',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      paddingRight: '6px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: this.props.tenant.primary,
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
  };

  CustomDropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator styles={this.customStyles} {...props}>
        <DropDownIndicator color={this.props.tenant.primary} />
      </components.DropdownIndicator>
    );
  };

  CustomInput = (props) => {
    return (
      <components.Input
        {...props}
        role="combobox"
        aria-describedby={`${props.id}-error`}
        aria-controls={`${props.id}-combobox-menu-list`}
        aria-expanded={props.selectProps.menuIsOpen}
        aria-activedescendant=""
      />
    );
  };

  CustomMenuList = (props) => {
    return (
      <components.MenuList {...props}>
        <div
          role="listbox"
          id={`${props.selectProps.inputId}-combobox-menu-list`}
        >
          {props.children}
        </div>
      </components.MenuList>
    );
  };

  CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div
          role="option"
          aria-selected={props.selectProps.value === props.children}
        >
          {props.children}
        </div>
      </components.Option>
    );
  };

  componentDidMount = async () => {
    this.state.countriesList = countriesListEn;
    this.state.countryTerritories = countryTerritoriesEn;
    this._isMounted = true;
    this.setState({
      dob: moment(this.props.user.dateOfBirth).format('MM/DD/YYYY'),
      state: this.props.user.state,
      country: this.props.user.country,
      education: this.props.user.educationLevel,
      highSchool: this.props.user.highSchool,
      graduationYear: this.props.user.graduationYear,
    });

    await this.getTerritories(this.props.user.state);
    if (!this.props.onboarding.highSchool) {
      await this.updateListOfSchools(this.props.user.highSchool);
      this.setState({
        highSchool: this.props.user.highSchool,
      });
    }
    await this.setListOfCountries();
    this.updateListOfSchools(this.props.user.state);
    i18n.on('languageChanged', this.handleLanguageChange);
  };

  setListOfCountries = () => {
    let countriesToInclude = Object.keys(this.state.countriesList).filter(
      (key) => this.state.countriesList[key].excluded === 'False'
    );

    const locale = i18n.language === 'fr' ? 'frText' : 'enText';
    countriesToInclude = countriesToInclude.map((country) => {
      return {
        value: country,
        label: this.state.countriesList[country][locale],
      };
    });
    countriesToInclude.sort((a, b) => {
      return String(a).localeCompare(String(b));
    });

    countriesToInclude.unshift({
      value: 'United States',
      label: locale === 'fr' ? i18n.t('United States') : 'United States',
    });
    // countriesToInclude.unshift({

    // countriesToInclude.push({
    //   value: 'Other Country',
    //   label: locale === 'fr' ? i18n.t('Other Country') : 'Other Country',
    // });

    this.setState({
      listOfCountries: countriesToInclude,
    });
  };

  handleTerritorySelected = async (
    territory,
    location,
    highSchoolError,
    gradYearError
  ) => {
    if (territory.value !== this.state.state && location === 'State') {
      this.updateChangesMadeAndSuccessMessage('updateProfileSuccess');
      await this.updateListOfSchools(territory.value);
      this.setState(
        {
          state: territory.value,
          highSchool: null,
          errors: {
            state: false,
            highSchool: highSchoolError,
            gradYear: gradYearError,
          },
        },
        () => {
          if (
            this.state.education === educationLevels().level1.value &&
            this.state.country === 'United States' &&
            this.props.tenant.name !== 'Baobab'
          ) {
            this.setState({
              errors: {
                state: false,
                highSchool: true,
                gradYear: gradYearError,
              },
            });
          }
        }
      );
    }
    if (territory.value !== this.state.country && location === 'Country') {
      this.updateChangesMadeAndSuccessMessage('updateProfileSuccess');
      if (territory.value !== 'United States') {
        this.setState({
          country: territory.value,
          state: null,
          highSchool: null,
          errors: {
            highSchool: false,
            state: false,
          },
        });
      }
      if (territory.value === 'United States' && this.state.state === null)
        this.setState({
          country: territory.value,
          errors: {
            state: true,
            highSchool: highSchoolError,
            gradYear: gradYearError,
          },
        });
    }
  };

  updateChangesMadeAndSuccessMessage = (successMessageToChange) => {
    const { changesMade } = this.state;
    if (!changesMade && successMessageToChange === 'updateProfileSuccess') {
      this.setState({
        changesMade: true,
      });
    }
    if (this.state[successMessageToChange]) {
      this.setState({
        [successMessageToChange]: false,
      });
    }
  };

  onInputChange = (event, successMessageToChange) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
    this.updateChangesMadeAndSuccessMessage(successMessageToChange);
  };

  handleEducationSelected = (education) => {
    const highSchoolValue =
      education.value !== educationLevels().level1.value
        ? null
        : this.state.highSchool;
    const gradYearValue =
      education.value !== educationLevels().level1.value
        ? null
        : this.state.graduationYear;
    const highSchoolError =
      education.value === educationLevels().level1.value &&
      this.state.highSchool === null &&
      this.state.country === 'United States';
    const gradYearError =
      education.value === educationLevels().level1.value &&
      this.state.graduationYear === null;
    if (education.value !== this.state.education) {
      this.setState(
        {
          education: education.value,
          highSchool: highSchoolValue,
          graduationYear: gradYearValue,
          errors: {
            highSchool: highSchoolError,
            gradYear: gradYearError,
          },
        },
        () => {
          this.updateChangesMadeAndSuccessMessage('updateProfileSuccess');
          if (this.state.education !== educationLevels().level1.value) {
            this.setState({
              errors: {
                highSchool: false,
              },
            });
          }
        }
      );
    }
  };

  handleGraduationYearSelected = (e, placeholder2, highSchoolError) => {
    if (e.value !== this.state.graduationYear) {
      this.updateChangesMadeAndSuccessMessage('updateProfileSuccess');
      this.setState({
        graduationYear: e.value,
        errors: {
          highSchool: highSchoolError,
          gradYear: false,
        },
      });
    }
  };

  handleHighSchoolSelected = (
    e,
    placeholder2,
    highSchoolError,
    gradYearError
  ) => {
    this.updateChangesMadeAndSuccessMessage('updateProfileSuccess');
    this.setState({
      highSchool: e.value,
      errors: {
        highSchool: false,
        gradYear: gradYearError,
      },
    });
  };

  updateListOfSchools = async (territory) => {
    await this.props.getSchools(territory);
    const schools = this.props.onboarding.highSchools;
    this.setState({
      listOfSchools: schools,
    });
  };
  handleLanguageChange = async () => {
    await this.setListOfCountries();
  };

  getTerritories = () => {
    const territoryList = Object.values(this.state.countryTerritories);
    territoryList.sort();
    const territoryOptions = territoryList.map((territory) => {
      return { value: territory, label: territory };
    });
    this.setState({ listOfTerritories: territoryOptions });
  };

  checkErrors = () => {
    const { errors } = this.state;
    return Object.values(errors).indexOf(true) > -1;
  };

  async handleErrors(targetId, inputValue) {
    const errorsCopy = cloneDeep(this.state.errors);
    const stateCopy = cloneDeep(this.state);
    const error = await validate(targetId, inputValue, errorsCopy, stateCopy);
    if (this._isMounted) {
      this.setState(
        () => ({
          errors: { ...error },
        }),
        () => {
          this.checkErrors();
        }
      );
    }
  }

  handleAWSErrors = (message) => {
    const { errors } = this.state;
    const errorsCopy = cloneDeep(errors);
    if (message.includes('previousPassword')) {
      errorsCopy.currentPassword = true;
    }
    if (message.includes('proposedPassword')) {
      errorsCopy.password = true;
    }
    if (message.includes('Incorrect username or password.')) {
      errorsCopy.currentPassword = true;
    }
    if (
      !message.includes('previousPassword') &&
      !message.includes('proposedPassword') &&
      !message.includes('Incorrect username or password.')
    ) {
      errorsCopy.somethingWentWrong = true;
    }
    this.setState({
      errors: errorsCopy,
    });
  };

  updateUserProfile = () => {
    const user = {
      id: this.props.onboarding.userData.user.id,
      dateOfBirth:
        this.state.dob || this.props.onboarding.userData.user.dateOfBirth,
      state: this.state.state === null ? null : this.state.state,
      country:
        this.state.country || this.props.onboarding.userData.user.country,
      highSchool:
        this.state.education !== educationLevels().level1.value ||
        this.state.highSchool === null
          ? null
          : this.state.highSchool ||
            this.props.onboarding.userData.user.highSchool,
      graduationYear:
        this.state.education !== educationLevels().level1.value
          ? null
          : this.state.graduationYear ||
            this.props.onboarding.userData.user.graduationYear,
      educationLevel:
        this.state.education ||
        this.props.onboarding.userData.user.educationLevel,
    };
    this.props.updateUserProfile(user, this.props.auth.jwtToken).then((res) => {
      if (res === 200) {
        this.setState({
          updateProfileSuccess: true,
          changesMade: false,
        });
      }
    });
  };

  handleUpdatePassword = async () => {
    const { errors, currentPassword, password } = this.state;
    if (!this.passwordsAreEmpty()) {
      const errorsCopy = cloneDeep(errors);
      errorsCopy.currentPassword = currentPassword.length === 0;
      errorsCopy.password = password.length === 0;
      this.setState(
        {
          errors: errorsCopy,
        },
        () => {
          this.handleErrors('password', password);
        }
      );
    }
    if (!this.checkErrors()) {
      if (!this.passwordsAreEmpty()) {
        try {
          const user = await Auth.currentAuthenticatedUser();
          const response = await Auth.changePassword(
            user,
            currentPassword,
            password
          );
          if (response === 'SUCCESS') {
            this.setState({
              password: '',
              confirmPass: '',
              currentPassword: '',
              passwordSuccess: true,
              changesMade: false,
              errors: {
                ...errors,
                password: false,
                currentPassword: false,
                somethingWentWrong: false,
              },
            });
          }
        } catch (e) {
          this.handleAWSErrors(e.message);
        }
      }
    }
  };

  passwordsAreEmpty = () => {
    const { currentPassword, password, confirmPass } = this.state;
    return (
      currentPassword.length === 0 ||
      password.length === 0 ||
      confirmPass.length === 0
    );
  };

  disablePasswordButton = () => {
    const { password, confirmPass, errors } = this.state;
    return (
      this.passwordsAreEmpty() || password !== confirmPass || errors.password
    );
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  backgroundColorSecondary = {
    backgroundColor: `${this.props.tenant.secondary}`,
  };

  colorPrimary = {
    color: `${this.props.tenant.primary}`,
  };

  buttonPrimary = {
    border: `1px solid ${this.props.tenant.primary}`,
    color: `${this.props.tenant.primary}`,
  };

  displayHighSchoolSection = () => {
    return (
      this.props.tenant.features.includes('highschool') &&
      this.state.education === educationLevels().level1.value
    );
  };

  togglePasswordMask = (pass) => {
    if (this._isMounted) {
      this.setState((prevState) => ({
        [`${pass}IsMasked`]: !prevState[`${pass}IsMasked`],
      }));
    }
  };

  keyDownPasswordMask(e, pass) {
    if (['Enter'].includes(e.key)) {
      this.togglePasswordMask(pass);
    }
  }

  displayLabelErrorSelect =
    (id, copyText, callbackFunc, list, placeholder1, placeholder2, stateValue) => (t) => {
      if (typeof placeholder1 === 'string' && placeholder1.includes('value')) {
        // placeholder1 = 'Albania';
      }
      const { errors } = this.state;
      const selectOne = t('Select One');
      return (
        <>
          <div className="label-and-error">
            <label
              className="label-registration registration-form-column"
              htmlFor={id}
              style={this.colorPrimary}
            >
              {copyText}
            </label>
            {id === 'highSchool' && this.state.country === 'United States' && (
              <span style={{ display: errors.highSchool ? '' : 'none' }}>
                <ErrorMessage id={`${id}-error`} error={selectOne} />
              </span>
            )}
            {id === 'state' && (
              <span style={{ display: errors.state ? '' : 'none' }}>
                <ErrorMessage id={`${id}-error`} error={selectOne} />
              </span>
            )}
            {id === 'graduationYear' && (
              <span style={{ display: errors.gradYear ? '' : 'none' }}>
                <ErrorMessage id={`${id}-error`} error={selectOne} />
              </span>
            )}
          </div>
          <Select
            components={{
              Input: this.CustomInput,
              MenuList: this.CustomMenuList,
              Option: this.CustomOption,
              DropdownIndicator: this.CustomDropdownIndicator,
            }}
            onChange={(e) => {
              callbackFunc(
                e,
                placeholder2,
                this.state.errors.highSchool,
                this.state.errors.gradYear
              );
            }}
            options={list}
            className="edit-profile-select"
            inputId={id}
            styles={this.customStyles}
            placeholder={this.updateValue(placeholder1, placeholder2, list)}
            aria-label={this.updateValue(placeholder1, placeholder2, list)}
            isDisabled={
              (placeholder2 === 'State' ||
                placeholder2 === 'High School Name') &&
              this.state.state === null &&
              this.state.country !== 'United States'
            }
            value={stateValue ? { value: stateValue, label: stateValue } : null}
          />
        </>
      );
    };

  displayLabelErrorPassword = (
    id,
    copyText,
    error,
    errorMessage,
    isPassMasked
  ) => {
    return (
      <>
        <div className="label-and-error">
          <label
            className="label-registration registration-form-column"
            htmlFor={id}
            style={this.colorPrimary}
          >
            {copyText}
          </label>
          <span style={{ display: error ? '' : 'none' }}>
            <ErrorMessage error={errorMessage} />
          </span>
        </div>
        <input
          disabled={getSSOProvider(
            this.props.onboarding.userData.user.cognitoUsername,
            this.props.tenant.name
          )}
          onChange={(e) => {
            this.onInputChange(e, 'passwordSuccess');
            this.handleErrors(e.target.id, e.target.value);
          }}
          type={isPassMasked ? 'password' : 'text'}
          className="edit-profile-input"
          id={id}
          value={this.state[id]}
        />
        <img
          className="password-eye register"
          onClick={() => {
            this.togglePasswordMask(id);
          }}
          onKeyDown={(e) => {
            this.keyDownPasswordMask(e, id);
          }}
          src={isPassMasked ? eyeIcon : eyeCrossIcon}
          alt={`${isPassMasked ? 'Show' : 'Hide'} ${copyText}`}
          tabIndex="0"
          role="button"
          aria-pressed={!isPassMasked}
        />
      </>
    );
  };
  updateValue = (placeholder1, placeholder2, list) => {
    const locale = i18n.language === 'fr' ? 'frText' : 'enText';
    if (countriesListEn[placeholder1]) {
      return countriesListEn[placeholder1][locale];
    }
    if (list.length > 0 && placeholder1) {
      try {
        const res = list.find((item) => item.value === placeholder1);
        return res.label;
      } catch (err) {
        console.log('err', err);
      }
    }
    return placeholder1 || placeholder2;
  };

  displayBaobabUserName = () => {
    const cognitoUsername = this.props.user?.cognitoUsername.toLowerCase();
    const usernameContainsBaobab = cognitoUsername.includes('baobab_');
    return usernameContainsBaobab ? (
      <Translation>
        {(t) => (
          <div className="row-to-column">
            <div className="form-label-error-input padding-right-desktop">
              <div className="label-and-error">
                <label
                  className="label-registration registration-form-column"
                  htmlFor="username"
                  style={this.colorPrimary}
                >
                  {t('Username (not editable)')}
                </label>
              </div>
              <input
                disabled
                type="text"
                className="edit-profile-input"
                id="username"
                value={cognitoUsername.substring(7, cognitoUsername.length)}
              />
            </div>
          </div>
        )}
      </Translation>
    ) : (
      <Translation>
        {(t) => (
          <div className="row-to-column">
            <div className="form-label-error-input padding-right-desktop">
              <div className="label-and-error">
                <label
                  className="label-registration registration-form-column"
                  htmlFor="username"
                  style={this.colorPrimary}
                >
                  {t('Name (not editable)')}
                </label>
              </div>
              <input
                disabled
                type="text"
                className="edit-profile-input"
                id="username"
                value={`${this.props.user.firstName} ${this.props.user.lastName}`}
              />
            </div>
          </div>
        )}
      </Translation>
    );
  };

  /**
   * @param educationEn Education selection value in English
   * @returns Translated educatation selection value or english fallback
   */
  getTranslatedEducationLabel(educationEn) {
    const educationTranslated = Object.values(educationLevels()).find(
      (level) => level.value === educationEn
    );

    if (educationTranslated) {
      return educationTranslated.value;
    }

    return educationEn;
  }

  render() {
    const currentYear = new Date().getFullYear();
    const yearChoices = [
      { value: currentYear, label: currentYear },
      { value: currentYear + 1, label: currentYear + 1 },
      { value: currentYear + 2, label: currentYear + 2 },
      { value: currentYear + 3, label: currentYear + 3 },
      { value: currentYear + 4, label: currentYear + 4 },
    ];
    const {
      errors,
      listOfSchools,
      state,
      country,
      highSchool,
      education,
      currentPasswordIsMasked,
      passwordIsMasked,
      confirmPassIsMasked,
      graduationYear,
    } = this.state;

    return (
      <Translation>
        {(t) => (
          <>
            <WindowTitle>{t('Edit Profile')}</WindowTitle>
            <div className="edit-profile">
              <a
                href="dashboard"
                style={this.colorPrimary}
                className="edit-profile__return-to-dashboard-link"
              >
                <Chevron
                  transform="rotate(180deg)"
                  color={this.props.tenant.primary}
                  ariaLabel="Click to return to the dashboard"
                />
                {t('Return to Dashboard')}
              </a>
              <h1 className="edit-profile-header">
                {t('Edit Personal Information')}
              </h1>
              <div
                className="secondary-underline"
                style={this.backgroundColorSecondary}
              />
              {/* email and dob */}
              {this.props.tenant.name !== 'Baobab' && (
                <div className="row-to-column">
                  <div className="form-label-error-input padding-right-desktop">
                    <div className="label-and-error">
                      <label
                        className="label-registration registration-form-column"
                        htmlFor="email"
                        style={this.colorPrimary}
                      >
                        {t('Email (not editable)')}
                      </label>
                    </div>
                    <input
                      disabled
                      type="text"
                      className="edit-profile-input"
                      id="email"
                      value={this.props.user?.email}
                    />
                  </div>
                  <div className="form-label-error-input">
                    <div className="label-and-error">
                      <label
                        className="label-registration registration-form-column"
                        htmlFor="dob"
                        style={this.colorPrimary}
                      >
                        {t('Date of Birth')}
                      </label>
                      <span
                        id="dob-error"
                        style={{ display: errors.dob ? '' : 'none' }}
                      >
                        <ErrorMessage error={t('Invalid date')} />
                      </span>
                    </div>
                    <InputMask
                      placeholder={this.state.dob}
                      id="dob"
                      className="edit-profile-input"
                      mask="99/99/9999"
                      value={this.state.dob}
                      maskPlaceholder="mm/dd/yyyy"
                      onChange={(e) => {
                        this.onInputChange(e, 'updateProfileSuccess');
                        this.handleErrors(e.target.id, e.target.value);
                      }}
                    />
                  </div>
                </div>
              )}
              {this.props.tenant.name === 'Baobab' &&
                this.displayBaobabUserName()}

              {/* Country and State */}

              <div className="row-to-column">
                <div className="form-label-error-input padding-right-desktop">
                  {this.displayLabelErrorSelect(
                    'country',
                    t('Country'),
                    this.handleTerritorySelected,
                    this.state.listOfCountries,
                    country,
                    'Country'
                  )(t)}
                </div>
                <div className="form-label-error-input padding-right-desktop">
                  {this.displayLabelErrorSelect(
                    'state',
                    t('State'),
                    this.handleTerritorySelected,
                    this.state.listOfTerritories,
                    state,
                    'State',
                    this.state.state
                  )(t)}
                </div>
              </div>

              {/* Education Level */}

              <div className="row-to-column">
                <div className="form-label-error-input">
                  {this.displayLabelErrorSelect(
                    'education',
                    t('Education Level'),
                    this.handleEducationSelected,
                    Object.values(educationLevels()),
                    this.getTranslatedEducationLabel(education),
                    t('Education Level')
                  )(t)}
                </div>
              </div>

              {/* High School Name and Graduation Year */}

              {this.displayHighSchoolSection() ? (
                <div className="row-to-column">
                  <div className="form-label-error-input padding-right-desktop">
                    {this.displayLabelErrorSelect(
                      'highSchool',
                      t('High School Name'),
                      this.handleHighSchoolSelected,
                      listOfSchools,
                      highSchool,
                      'High School Name'
                    )(t)}
                  </div>
                  <div className="form-label-error-input">
                    {this.displayLabelErrorSelect(
                      'graduationYear',
                      t('Graduation Year'),
                      this.handleGraduationYearSelected,
                      yearChoices,
                      graduationYear,
                      'Graduation Year'
                    )(t)}
                  </div>
                </div>
              ) : null}
              <div className="row-to-column button-container">
                <button
                  type="button"
                  tabIndex={0}
                  className={`button--primary primary-not-filled ${this.props.classes.nonFilledButton}`}
                  style={{ marginRight: '17px' }}
                  onClick={() => {
                    this.props.history.push('dashboard');
                  }}
                  onKeyDown={(e) => {
                    if (['Enter'].includes(e.key)) {
                      this.props.history.push('dashboard');
                    }
                  }}
                >
                  {t('Cancel')}
                </button>
                <div className="edit-profile__column">
                  <button
                    disabled={
                      !this.state.changesMade ||
                      this.state.errors.highSchool ||
                      this.state.errors.state ||
                      this.state.errors.gradYear ||
                      this.state.errors.dob
                    }
                    type="button"
                    tabIndex={0}
                    className={
                      this.state.changesMade
                        ? `button--primary primary-filled save-changes ${this.props.classes.filledButton}`
                        : `button--primary primary-filled save-changes`
                    }
                    onClick={() => {
                      this.updateUserProfile();
                    }}
                    onKeyDown={(e) => {
                      if (['Enter'].includes(e.key)) {
                        this.updateUserProfile();
                      }
                    }}
                    style={{ padding: ' 0 34px' }}
                  >
                    {t('Save Changes')}
                  </button>
                  <ChangesSaved
                    idValue="-info"
                    message={t('Changes Saved')}
                    stateValToDetermineShowing={this.state.updateProfileSuccess}
                  />
                </div>
              </div>
              <h1 className="edit-profile-header">{t('Reset Password')}</h1>
              <div
                className="secondary-underline"
                style={this.backgroundColorSecondary}
              />

              {/* old password and new password */}

              {getSSOProvider(
                this.props.onboarding.userData.user.cognitoUsername,
                this.props.tenant.name
              ) && (
                <div className="edit-profile__sso-provider-password">
                  {t(
                    'This account was created using {{ssoOrganization}}. To reset your me3 password you will need to do so with {{ssoOrganization}} and log in with the newly set password. ',
                    {
                      ssoOrganization: getSSOProvider(
                        this.props.onboarding.userData.user.cognitoUsername,
                        this.props.tenant.name
                      ),
                    }
                  )}
                </div>
              )}

              <div className="row-to-column current-password">
                <div className="form-label-error-input padding-right-desktop password-container">
                  {this.displayLabelErrorPassword(
                    'currentPassword',
                    t('Current Password'),
                    errors.currentPassword,
                    t('Incorrect Password'),
                    currentPasswordIsMasked
                  )}
                </div>
              </div>
              <div className="row-to-column">
                <div className="form-label-error-input password-container padding-right-desktop">
                  {this.displayLabelErrorPassword(
                    'password',
                    t('New Password'),
                    errors.password,
                    t('Invalid Password'),
                    passwordIsMasked
                  )}
                </div>
                <div className="form-label-error-input password-container">
                  {this.displayLabelErrorPassword(
                    'confirmPass',
                    t('Confirm Password'),
                    errors.confirmPass,
                    t(`Passwords Don't Match`),
                    confirmPassIsMasked
                  )}
                </div>
              </div>
              <div className="password-requirements">
                {t(
                  '* At least 8 characters, including a lowercase letter, an uppercase letter, and a number.'
                )}
              </div>
              <span
                style={{ display: errors.somethingWentWrong ? '' : 'none' }}
              >
                <ErrorMessage
                  error={t('Something went wrong. Please try again later.')}
                />
              </span>
              <div className="edit-profile__save-pass-button-container">
                <div className="edit-profile__column edit-profile__save-pass-button">
                  <button
                    type="button"
                    disabled={this.disablePasswordButton()}
                    tabIndex={0}
                    className={
                      this.disablePasswordButton()
                        ? `button--primary primary-filled save-changes`
                        : `button--primary primary-filled save-changes ${this.props.classes.filledButton}`
                    }
                    onClick={() => {
                      this.handleUpdatePassword();
                    }}
                    onKeyDown={(e) => {
                      if (['Enter'].includes(e.key)) {
                        this.handleUpdatePassword();
                      }
                    }}
                    style={{ padding: ' 0 34px' }}
                  >
                    {t('Submit Password')}
                  </button>
                  <ChangesSaved
                    idValue="-password"
                    message={t('New password saved')}
                    stateValToDetermineShowing={this.state.passwordSuccess}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const auth = getAuthState(state);
  const onboarding = getOnboardingState(state);
  return { auth, onboarding };
};

const EditProfileWithRouter = withRouter(
  connect(mapStateToProps, { getSchools, updateUserProfile })(EditProfile)
);

export default withStyles(styles)(EditProfileWithRouter);
